<div class="shell">
  <header class="masthead">
    <img class="masthead__logo" src="OCSLA%20Blanco.png" alt="OCSLA" width="696" height="193" />
    <div class="masthead__divider" aria-hidden="true"></div>
    <div class="masthead__text">
      <h1 class="masthead__title">Hub de portales</h1>
      <p class="masthead__subtitle">Elige un portal para abrirlo en una pestaña nueva</p>
    </div>
  </header>

  <main class="grid">
    @for (portal of portals; track portal.id) {
      <app-portal-card [portal]="portal" />
    }
  </main>

  <footer class="footer">
    <img class="footer__mark" src="OCSLA%20Blanco.png" alt="" aria-hidden="true" />
    <span>Plataforma OCSLA</span>
  </footer>
</div>
